import { red, teal, lightBlue, lightGreen } from "@mui/material/colors";

export const RANDOM_COLORS: string[] = [
  "#F94144",
  "#F3722C",
  "#F8961E",
  "#F9844A",
  "#F9C74F",
  "#90BE6D",
  "#43AA8B",
  "#4D908E",
  "#577590",
  "#277DA1",
];

export const COLOR = {
  POST: teal[900],
  DELETE: red[900],
  PUT: lightBlue[900],
  PATCH: lightBlue[900],
  GET: lightGreen[900],
};
